import { __decorate } from "tslib";
import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { PsHttpService } from '@patsnap/tahiti-core/common/ps-http';
import { WORKSPACE_SERVICE_URI } from '@cores/constants/envConfig';
let KeywordSearchApiImpl = class KeywordSearchApiImpl extends PsHttpService {
    get options() {
        return {
            baseURL: `${WORKSPACE_SERVICE_URI}/workspace/web`,
            headers: {
                'X-API-Version': '2.0',
            },
        };
    }
    async getKeywordSuggest(keyword) {
        const res = await this.get({
            url: '/keyword/suggest',
            params: {
                keyword,
            },
        });
        return res.data;
    }
};
KeywordSearchApiImpl = __decorate([
    injectable()
], KeywordSearchApiImpl);
export { KeywordSearchApiImpl };
